var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadX2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C12.5523 4 13 4.44772 13 5L13 14.4216L15.8787 11.5429C16.2692 11.1524 16.9024 11.1524 17.2929 11.5429C17.6834 11.9334 17.6834 12.5666 17.2929 12.9571L12.8287 17.4214C12.796 17.4677 12.759 17.5119 12.7175 17.5533C12.5196 17.7512 12.2593 17.8489 11.9999 17.8462C11.7406 17.8488 11.4804 17.7512 11.2825 17.5533C11.241 17.5119 11.204 17.4677 11.1713 17.4214L6.70711 12.9571C6.31658 12.5666 6.31658 11.9334 6.70711 11.5429C7.09763 11.1524 7.7308 11.1524 8.12132 11.5429L11 14.4216L11 5C11 4.44772 11.4477 4 12 4ZM3 20.25C3 19.6977 3.44772 19.25 4 19.25H20C20.5523 19.25 21 19.6977 21 20.25C21 20.8023 20.5523 21.25 20 21.25H4C3.44772 21.25 3 20.8023 3 20.25Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadX2);
export default __webpack_public_path__ + "static/media/DownloadX2.ca08a63b504ceadda3c9abfa1b924697.svg";
export { ForwardRef as ReactComponent };